var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Remove Addon Domain")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm.showLoading
              ? _c("v-progress-linear", {
                  attrs: {
                    indeterminate: "",
                    color: "green",
                    height: "4"
                  }
                })
              : [
                  _c("p", [
                    _vm._v(" Are you sure you wish to "),
                    _c("strong", [_vm._v("permanently")]),
                    _vm._v(
                      " remove the addon domain “" +
                        _vm._s(_vm.addonDomain.domain) +
                        "”? "
                    )
                  ]),
                  _vm.ftpAccount
                    ? _c("v-checkbox", {
                        attrs: {
                          color: "green",
                          "hide-details": "",
                          label: "Delete the associated FTP account"
                        },
                        model: {
                          value: _vm.deleteRelatedFtpAccount,
                          callback: function callback($$v) {
                            _vm.deleteRelatedFtpAccount = $$v
                          },
                          expression: "deleteRelatedFtpAccount"
                        }
                      })
                    : _vm._e()
                ]
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.deleteAddon
                }
              },
              [_vm._v("Remove")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }